@if (showCheckboxes()) {
  <div class="view-checkbox-group">
    @for (opt of multiSelectOptions(); track opt.value) {
      <glxy-checkbox
        [label]="opt.label | translate"
        [formControl]="getCheckboxControl(opt.value)"
        [attr.data-testid]="opt.testId"
      ></glxy-checkbox>
    }
  </div>
} @else {
  <mat-radio-group [formControl]="radioControl" class="view-radio-group">
    @for (opt of options(); track opt.value) {
      <mat-radio-button
        [value]="opt.value"
        [attr.data-testid]="opt.testId"
        (click)="onRadioClick($event, opt.value)"
      >
        {{ opt.label | translate }}
      </mat-radio-button>
    }
  </mat-radio-group>
}
